

<div class="wwf-carousel-wrapper" *ngIf="slides && cont && blog">
  <div class="wwf-carousel-fake" *ngIf="this.car.older>=0" [style.background]="'url('+api.getImageUrl(slides[this.car.older].image)+')'"></div>
  <div class="wwf-carousel" *ngFor="let item of slides; let i = index" [hidden]="i!=car.current">
    <div class="wwf-carousel-slide" *ngIf="i==car.current">
      <div class="wwf-carousel-banner">
        <div class="wwf-carousel-mask ts-background-{{i+2}} animate"></div>
        <div class="back-mask" role="img" [attr.aria-label]="item.name" [style.background]="'url('+api.getImageUrl(item.image)+')'"></div>
      </div>
      <div class="wwf-carousel-panel wow slideInRight" data-wow-delay="1s">
        <h3>{{item.name}}</h3>
        <a href="{{item.title.es}}" target="_blank" class="btn-theme ts-background-4">ver más</a>
      </div>
    </div>
  </div>
  <div class="wwf-carousel-tabs">
    <div class="wwf-carousel-tabs-arrow left" (click)="changeSlide('prev', slides.length)">
      <svg width="28.536" height="17.803" viewBox="0 0 28.536 17.803">
        <path id="chevron" d="M2420,308.188l12.5,12.5,12.5-12.5" transform="translate(-2418.232 -306.42)" fill="none"
          stroke="#fff" stroke-width="5" />
      </svg>
    </div>
    <div class="wwf-carousel-tabs-bullet" [class.active]="i==car.current" (click)="changeSlide(i, slides.length)"
      *ngFor="let item of slides; let i = index">
    </div>
    <div class="wwf-carousel-tabs-arrow right" (click)="changeSlide('next', slides.length)">
      <svg width="28.536" height="17.803" viewBox="0 0 28.536 17.803">
        <path id="chevron" d="M2420,308.188l12.5,12.5,12.5-12.5" transform="translate(-2418.232 -306.42)" fill="none"
          stroke="#fff" stroke-width="5" />
      </svg>
    </div>
  </div>
</div>


<app-widgets [data]="cont.section" *ngIf="slides && cont && blog"></app-widgets>

<div class="wrapper-content-fitted gray" *ngIf="slides && cont && blog">
  <div class="wrapper-header">
    <h1 class="text-center">El proyecto en imagenes</h1>
    <h5 class="text-center">Entérate de lo último</h5>
  </div>
  <app-card class="wwf-box" *ngFor="let card of blog" [card]="card" [conf]="{color: 4, type: 'section', route:'articulo'}"></app-card>
</div>

<app-footer  *ngIf="slides && cont && blog"></app-footer>
